import { FC, ReactNode } from 'react'

import { cn } from '@bem-react/classname'

import './Title.scss'

interface ITitleProps {
  className?: string
  children?: ReactNode
}

const cnTitle = cn('Title')

export const Title: FC<ITitleProps> = ({ className, children }) => {
  return <div className={cnTitle(null, [className])}>{children}</div>
}
